import { render, staticRenderFns } from "./VasionPager.vue?vue&type=template&id=46ecdcaf&scoped=true&"
import script from "./VasionPager.vue?vue&type=script&lang=js&"
export * from "./VasionPager.vue?vue&type=script&lang=js&"
import style0 from "./VasionPager.vue?vue&type=style&index=0&id=46ecdcaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ecdcaf",
  null
  
)

export default component.exports